import React from "react";
import { Card, Descriptions, Typography } from "antd";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{ financials: Record<string, unknown> }} props
 */
export default function OperationRequestFinancialCard({ financials }) {
  return (
    <Card className={styles.sidebarCard} size="small" title="מידע כספי">
      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item label="סכום הזמנה">
          <Text>{financials.displayTotalText || "—"}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="שולם">
          <Text>{financials.displayPaidText || "—"}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="יתרה">
          <Text>{financials.displayRemainingText || "—"}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="מטבע מקור (SSOT)">
          <Text dir="ltr">{financials.sourceCurrencyLabel || "—"}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="שער המרה">{financials.exchangeRateLabel || "—"}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
